export const iconFontAwesomeMapsLemon = (
	<i className="fa-solid fa-lemon"></i>
);
